import { combineReducers } from "redux"
import { user } from './rootAccessReducer'

const rootAccessReducer = combineReducers({
    user,
})

export default rootAccessReducer